export default "__VITE_ASSET__zUl8lzyk__"